const EINSATZORT_VALUE_SEP = '\u001f'

export const MIN_DAYS_BEFORE_BEGINN = 8
export const BEWILLIGUNG_LINK_I18N_KEY = 'footer.bewilligung-oder-meldung.link'
export const MINDESTLOHN_LINK_I18N_KEY = 'mindestlohnrechner.actions.mindestloehne.url'
export const GAV_KUERZE_LINK_I18N_KEY = 'mindestlohnrechner.actions.gavKurz.url'
export const KONTAKTE_LINK_I18N_KEY = 'mindestlohnrechner.actions.kontakte.url'

export const RESULT_PAGE = {
  MINDESTLOEHNE: 'mindestloehne',
  GAV_KURZ: 'gavKurz',
  KONTAKTE: 'kontakte',
  NO_MATCH: 'noMatch'
}

const ALLOWED_HTML_TAGS = new Set([
  'a', 'br', 'p', 'div', 'span', 'strong', 'em', 'b', 'i',
  'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td'
])

const ALLOWED_ATTRS_BY_TAG = {
  a: new Set(['href', 'target', 'rel']),
  td: new Set(['colspan', 'rowspan']),
  th: new Set(['colspan', 'rowspan'])
}
const SPAN_ATTRS = new Set(['colspan', 'rowspan'])
const SAFE_HREF_PREFIXES = ['http://', 'https://', 'mailto:', 'tel:', '/', '#']

function isSafeHref(href) {
  if (!href) {
    return false
  }
  const normalized = href.trim().toLowerCase()
  return SAFE_HREF_PREFIXES.some(prefix => normalized.startsWith(prefix))
}

function sanitizeElement(element) {
  const tag = element.tagName.toLowerCase()

  if (!ALLOWED_HTML_TAGS.has(tag)) {
    const parent = element.parentNode
    if (!parent) {
      return
    }
    while (element.firstChild) {
      parent.insertBefore(element.firstChild, element)
    }
    parent.removeChild(element)
    return
  }

  const allowedAttrs = ALLOWED_ATTRS_BY_TAG[tag] || new Set()
  Array.from(element.attributes).forEach(attr => {
    const name = attr.name.toLowerCase()
    const value = attr.value || ''
    if (!allowedAttrs.has(name) || name.startsWith('on')) {
      element.removeAttribute(attr.name)
      return
    }
    if (name === 'href' && !isSafeHref(value)) {
      element.removeAttribute(attr.name)
    }
    if (SPAN_ATTRS.has(name) && !/^[1-9]\d*$/.test(value.trim())) {
      element.removeAttribute(attr.name)
    }
  })

  if (tag === 'a') {
    const href = element.getAttribute('href')
    if (!href) {
      element.removeAttribute('target')
      element.removeAttribute('rel')
    } else {
      element.setAttribute('target', '_blank')
      element.setAttribute('rel', 'noopener noreferrer')
    }
  }
}

export function sanitizeRichTextHtml(value) {
  if (!value) {
    return ''
  }

  const parser = new DOMParser()
  const doc = parser.parseFromString(`<div>${value}</div>`, 'text/html')
  const container = doc.body.firstElementChild
  if (!container) {
    return ''
  }

  const elements = Array.from(container.querySelectorAll('*'))
  elements.forEach(sanitizeElement)
  return container.innerHTML
}

export function gemeindeOptionValue(gemeinde) {
  return [gemeinde.plz, gemeinde.kanton, gemeinde.ort].join(EINSATZORT_VALUE_SEP)
}

export function formatGemeindeDropdownLabel(gemeinde) {
  return `${gemeinde.plz} - ${gemeinde.ort} (${gemeinde.kanton})`
}

export function resolveTrefferName(treffer, lang) {
  const isValidTitle = value => typeof value === 'string' && value.trim() !== '' && !/^\d+$/.test(value.trim())
  const pickFirstValid = (...values) => values.find(isValidTitle) || ''

  if (lang === 'fr') {
    return pickFirstValid(treffer.nameFr, treffer.nameDe, treffer.nameIt) || (treffer.contractNumber || '')
  }
  if (lang === 'it') {
    return pickFirstValid(treffer.nameIt, treffer.nameDe, treffer.nameFr) || (treffer.contractNumber || '')
  }
  return pickFirstValid(treffer.nameDe, treffer.nameFr, treffer.nameIt) || (treffer.contractNumber || '')
}

export function toIsoDate(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function todayPlusDays(days) {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  d.setDate(d.getDate() + days)
  return d
}
